import { almiOnSofa } from "../../assets/images";
import { HeaderBanner } from "../../shared/components/HeaderBanner";
import { STATUS_CONTENT } from "./data";
import { SpeechBubble } from "./SpeechBubble";
import PreloadedImage from "../../shared/components/PreloadedImage/PreloadedImage";
import styles from "./ServerStatusDino.module.scss";
import clsx from "clsx";

interface ServerStatusDinoProps {
  status: "server-ok" | "server-error";
}

export const ServerStatusDino = ({ status }: ServerStatusDinoProps) => {
  const { title } = STATUS_CONTENT[status];

  return (
    <div className={clsx(styles.dinoContainer)}>
        <SpeechBubble status={status} />
        <HeaderBanner type="card" className={styles.headerBanner}>
          {title}
        </HeaderBanner>
        <PreloadedImage
          src={almiOnSofa}
          alt="Алми на софе"
          className={styles.characterImage}
          width={920}
          height={628}
          placeholderColor="var(--bg-pic-flowers-main-color)"
          customContainerClass={styles.characterWrapper}
        />
    </div>
  );
};
